// import { Person } from './Person'
import {RestCalorieConsumption} from './CalorieConsumption'

export class DailyCalorieConsumption {

    constructor(person) {
        this.calorieConsumptions = [],
        this.person = person
    }

    /**
     * function for adding a calorieConsumption object to an array
     * @param {CalorieConsumption} calorieConsumption
     */
    addCalorieConsumption(calorieConsumption) {
        this.calorieConsumptions.push(calorieConsumption)
    }

    /**
     * calculates all calories needed for different activities 
     * and combines these values to a daily calorie consumption
     * @returns accumulated Calories for one day
     */
    get calcCalories() {
        // adds all hours spend on activities
        var productiveHours = this.calorieConsumptions.reduce(function (acc, val) {
            return acc + val.hours
        }, 0)
        let restHours = 24-productiveHours
        if (restHours < 0) {
            restHours = 0
        }
        let restCalorieConsumption = new RestCalorieConsumption(this.person, restHours)
        // adds all calories spend on activities
        var accumulatedCalories = this.calorieConsumptions.reduce(function (acc, val) {
            return acc + val.calcCalories
        }, 0)
        accumulatedCalories += restCalorieConsumption.calcCalories
        return accumulatedCalories
    }
}